export default __webpack_public_path__ + "static/media/influencer_card4.f0da1b35.png";